export const oneQuarter = date => {
  let startDate;
  let endDate;
  const month = date.getMonth();
  if (month === 0 || month === 1 || month === 2) {
    startDate = `01/01/${date.getFullYear()}`;
    endDate = `03/31/${date.getFullYear()}`;
    return { start: startDate, end: endDate };
  } else if (month === 3 || month === 4 || month === 5) {
    startDate = `04/01/${date.getFullYear()}`;
    endDate = `06/30/${date.getFullYear()}`;
    return { start: startDate, end: endDate };
  } else if (month === 6 || month === 7 || month === 8) {
    startDate = `07/01/${date.getFullYear()}`;
    endDate = `09/30/${date.getFullYear()}`;
    return { start: startDate, end: endDate };
  } else if (month === 9 || month === 10 || month === 11) {
    startDate = `10/01/${date.getFullYear()}`;
    endDate = `12/31/${date.getFullYear()}`;
    return { start: startDate, end: endDate };
  }
};
